import Client from '../client';
import { AxiosResponse } from 'axios';
import BaseService from '../baseService/baseService';

const ComissaoService = {
    deletarExcelParametros(fileRequest: any) {
        return BaseService.conectarEndpoint(fileRequest, 'compensation/comissao/excel/deletar', 'excelComissaoDeletar');
    },
    comissaoExcelPost(fileRequest: any) {
        return BaseService.conectarEndpoint(fileRequest, 'compensation/comissao/excel', 'excelComissao');
    },
    obterExcel(): Promise<void | AxiosResponse<any>> {
        return Client.getBlob('compensation/comissao/excel');
    },
    enviarParametrosAoEventGrid(): Promise<void | AxiosResponse<any>> {
        return Client.post('compensation/comissao/eventGrid', {});
    }
};

export default ComissaoService;